import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Bookings from "@/pages/Bookings";
import Library from "@/pages/Library";
import ContentDetail from "@/pages/ContentDetail";
import About from "@/pages/About";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Cart from "@/pages/Cart";
import Blueprint from "@/pages/Blueprint";
import WealthBlueprint from "@/pages/WealthBlueprint";
import Decode from "@/pages/Decode";
import Mentorship from "@/pages/Mentorship";
import Masterclass from "@/pages/Masterclass";
import SacredTools from "@/pages/SacredTools";
import Pattern from "@/pages/Pattern";
import InnerCircle from "@/pages/InnerCircle";
import AuthCallback from "@/pages/AuthCallback";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PolicyPage from "@/pages/PolicyPage";
import { PageTracker } from "@/components/PageTracker";

import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { CurrencyProvider } from "@/context/CurrencyContext";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
    <PageTracker />
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/:slug" element={<ProductDetail />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/blueprint" element={<Blueprint />} />
        <Route path="/wealth-blueprint" element={<WealthBlueprint />} />
        <Route path="/decode" element={<Decode />} />
        <Route path="/mentorship" element={<Mentorship />} />
        <Route path="/masterclass" element={<Masterclass />} />
        <Route path="/sacred-tools" element={<SacredTools />} />
        <Route path="/pattern" element={<Pattern />} />
        <Route path="/circle" element={<InnerCircle />} />
        <Route path="/bookings" element={<Bookings />} />
        <Route path="/library" element={<Library />} />
        <Route path="/library/:slug" element={<ContentDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/policies/:slug" element={<PolicyPage />} />
        <Route path="*" element={<Home />} />
      </Route>
    </Routes>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <CurrencyProvider>
        <CartProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster
            theme="light"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "rgba(255,255,255,0.95)",
                border: "1px solid rgba(40,75,99,0.18)",
                color: "#1a2530",
                fontFamily: "'Plus Jakarta Sans', sans-serif",
              },
            }}
          />
        </BrowserRouter>
        </CartProvider>
      </CurrencyProvider>
    </AuthProvider>
  );
}

export default App;
